import AddClient from '../../components/add-client/AddClient';

const AddClientPage = () => {
  return <AddClient />;
};

export default AddClientPage;
